<template>
    <v-container>
      <template>
        <div class="text-center">
            <v-dialog
                v-model="dialog"
                width="800"
                @click:outside="closeModal"
                :retain-focus="false"
                persistent
            >
            <v-card class="" rounded="0" >
              <v-toolbar flat color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{
                  $t("Add New Record")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="py-5">
                <v-row  >
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('animal.conceptionInfo.pregnancyCheckDate')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>{{$t('animal.conceptionInfo.pregCheckDateH')}}.</span>
                            </v-tooltip>
                        </label>
                        <v-menu
                            v-model="showPregCheck"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="animal.pregnancyCheckDate"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :placeholder="$t('animal.conceptionInfo.selectDate')"
                          @click:append="showPregCheck = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="animal.pregnancyCheckDate"
                        @input="showPregCheck = false"
                      ></v-date-picker>
                    </v-menu>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label >{{$t('animal.conceptionInfo.conceptionSuccess')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span>{{$t('animal.conceptionInfo.conceptionSuccessH')}}.</span>
                            </v-tooltip>
                        </label>
                        <v-select
                            :items="[
                            { text: $t('yes'), value: 'true' },
                            { text: $t('no'), value: 'false' },
                            ]"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            v-model="animal.conceptionSuccess"
                            :placeholder="$t('yes')"
                        ></v-select>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('animal.conceptionInfo.pregnancyCheckOperator')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.pregnancyCheckOperatorH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-text-field
                            type="text"
                            outlined
                            dense
                            :placeholder="$t('animal.geneticWorthInfo.checkLTD')"
                            v-model="animal.pregnancyCheckOperatorName"
                        ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('animal.conceptionInfo.pregnancyCheckMethod')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.pregnancyCheckMethodH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-select
                            :items="pregnancyCheckTypes"
                            outlined
                            placeholder="Select Method"
                            dense
                            v-model="animal.pregnancyCheckMethod"
                        ></v-select>
                    </v-col>

                </v-row>
                <hr>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined n-width="50px" @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" min-width="50px" @click="registerConception">Submit</v-btn>
                </v-card-actions>
            </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"
      ></DataLostWarning>
    </v-container>
  </template>
  
  <script>
  import loadingMixin from "@/mixins/LoadingMixin";
  import generalMixin from "@/mixins/GeneralMixin";
//   import GeneralService from "@/_services/GeneralService";
  import AnimalService from "@/_services/AnimalService";
  import { breeds } from "@/models/units.js";

  export default {
    components: {
    },
    created() {
        this.assignValue()
    },
    computed: {
      dialog() {
        return this.dialogI;
      },
    },
    data() {
      return {
        showPregCheck: false,
        pregnancyCheckTypes:[
            "Manual Palpation of the reproductive tract (per rectum)",
            "Transrectal ultrasonograpghy of the reproductive tract",
            "Other"
        ],
        breeds,
        matingDateMenuSE: false,
        dataLossWarning: false,
        animal: {
            animalNumber: this.$route.params.animal_number,
            pregnancyCheckDate: "", //(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            conceptionSuccess: "",
            pregnancyCheckOperatorName: "",
            pregnancyCheckMethod: "",
        },
      };
    },
    methods: {
        assignValue() {
            this.animal.id = this.editedItem.id
            this.animal.pregnancyCheckDate = this.editedItem.pregnancyCheckDate
            this.animal.conceptionSuccess = this.editedItem.conceptionSuccess == 'Yes' ? 'true': 'false'
            this.animal.pregnancyCheckOperatorName = this.editedItem.pregnancyCheckOperatorName
            this.animal.pregnancyCheckMethod = this.editedItem.pregnancyCheckMethod
            // console.log(this.editedItem)
        },
      closeWarningMessage(res) {
        this.dataLossWarning = false;
        if (!res) {
          this.$emit("closeAddUser");
        }
      },

      closeModal() {
        this.dataLossWarning = true;
      },
      registerConception() {
        let isEmpty = true
        Object.entries(this.animal).forEach(([key, value]) => {
            if(key != 'animalNumber' && value != ""){
                isEmpty = false
                console.log(key, value)
            }
        })

        if(isEmpty){
            this.$notify({
                title: this.$t('Nothing to add'),
                type: "error"
            });
            return;
        }
        this.startLoading();
        this.formChanged = false;
        AnimalService.updateAnimalConception(this.animal, 'pregnancy')
            .then((res) => {
            if (res.success) {
                this.$notify({
                title: this.$t('animal.conceptionInfo.animalConceptionAddedSuccessfully'),
                text: res.message,
                type: "success",
                position: "top right",
                });
            } else {
                this.$notify({
                title: this.$t('somethingWentWrong'),
                text: res.message,
                type: "error",
                position: "top right",
                });
            }
            this.$emit('added')
            this.stopLoading();
            })
            .catch((err) => {
            console.log(err.data);
            this.stopLoading();
            });
    },
  
    },
    props: {
      dialogI: {
        type: Boolean,
        required: true,
      },
      editedItem: {
        type: Object,
        required: true
      }
    },
    mixins: [loadingMixin, generalMixin],
  };
  </script>
  
  <style>

  </style>
  